<mat-expansion-panel #expansionPanel>
 <mat-expansion-panel-header>
  <mat-panel-title>
   <mat-icon *ngIf="isAnyInEditMode && !expansionPanel.expanded"
             color="accent"
             class="unsavedChangesTolltipIcon"
             matTooltip="Dieser Abschnitt enthält ungespeicherte Änderungen">
    edit
   </mat-icon>
   <ng-content select="[header]"></ng-content>
  </mat-panel-title>
 </mat-expansion-panel-header>
 <ng-content></ng-content>
</mat-expansion-panel>